import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "@/config";

Vue.use(Vuex);

const Calendar = {
    namespaced: true,
    state: {
        events: [],
        event: {},
    },
    getters: {
        events: state => state.events || null,
        curEvent: state => state.event || null,
    },
    mutations: {
        events(state, events) {
            state.events = events;
        },
        addEvent(state, event) {
            state.events.push(event);
        },
        setCurrentEvent(state, event) {
            //console.log(event);
            state.event = event;
        },
        removeEvent(state, event) {
            const idx = state.events.findIndex(evt => evt.id == event.id);
            state.events.splice(idx, 1);
        }
    },
    actions: {
        fetchEvents({ rootState, commit }) {
            return new Promise((resolve, reject) => {
                axios.get(config.API_URL + '/grants/' + rootState.project.grant_id + '/events')
                    .then(response => {
                        commit('events', response.data.data);
                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        create({ rootState, commit }, event) {
            return new Promise((resolve, reject) => {
                axios.post(config.API_URL + '/events', { project_id: rootState.project.uuid, ...event })
                    .then(response => {
                        commit('addEvent', response.data.data);
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        updateEvent({ getters, commit }) {
            let event = getters.curEvent;
            return new Promise((resolve, reject) => {
                axios.put(config.API_URL + '/events/' + event.id, { ...event })
                    .then(response => {
                        commit('removeEvent', event);
                        commit('addEvent', response.data.data);
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        fetchEventDetails({ getters, commit }) {
            let event = getters.curEvent;
            return new Promise((resolve, reject) => {
                axios.get(config.API_URL + '/events/' + event.id)
                    .then(response => {

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        destroyEvent({ getters, commit }) {
            let event = getters.curEvent;
            return new Promise((resolve, reject) => {
                axios.delete(config.API_URL + '/events/' + event.id)
                    .then((response) => {
                        commit('removeEvent', event);
                        commit('setCurrentEvent', {});
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })

        }
    }
}

export default Calendar;